import * as type from '../mutation-types'

export const kegelbahnStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      alleKegelbahnen: 'kegelbahn/all',
      repairMyKegelbahn: 'kegelbahn/repair',
      byNewKegelbahn: 'kegelbahn/byNewKegelbahn'
    },
    imageURL: '/static/game/kegelbahnen/',
    kegelbahn: {},
    ausbau: {
      inBau: false, // wurde neues Fahrzeug gekauft
      currentVal: 0,
      kegelbahn: {}
    },
    kegelbahnen: {},
    cacheTime: 0 // in sec
  },
  mutations: {
    [type.KEGELBAHN_RESET] (state) {
      state.kegelbahn = {}
      state.ausbau = {
        inBau: false,
        currentVal: 0,
        kegelbahn: {}
      }
      state.kegelbahnen = {}
      state.cacheTime = 0
    },
    [type.KEGELBAHN_SET_KEGELBAHNEN] (state, data) {
      state.kegelbahnen = data
    },
    [type.KEGELBAHN_SET_MY_KEGELBAHN] (state, data) {
      state.kegelbahn = data
      // setze mannschaftsrekord wenn nicht vorhanden
      if (!state.kegelbahn.rekord || !state.kegelbahn.rekord.ergebnis) {
        state.kegelbahn.rekord = {
          ergebnis: 0,
          saison: {
            name: '-',
            spieltag: 0
          },
          date: '01.05.2019',
          user: {
            teamname: '-'
          },
          players: []
        }
      }

      // setze einzelrekord wenn nicht vorhanden fuer view
      if (!state.kegelbahn.rekord || !state.kegelbahn.rekord.einzel) {
        state.kegelbahn.rekord.einzel = {
          ergebnis: 0,
          name: '-',
          user: {
            teamname: '-'
          },
          saison: {
            name: '-',
            spieltag: 0
          },
          dataum: '01.05.2019'
        }
      }
    },
    [type.KEGELBAHN_SET_ZUSTAND] (state, data) {
      state.kegelbahn.zustand = data
    },
    [type.KEGELBAHN_SET_CACHE_TIME] (state) {
      state.cacheTime = Math.floor(new Date().getTime() / 1000)
    },
    [type.KEGELBAHN_SET_AUSBAU] (state, data) {
      state.ausbau.inBau = data.kegelbahnInBau
      state.ausbau.kegelbahn = data.kegelbahn
      state.ausbau.currentVal = data.kegelbahnCurrentVal
    }
  },
  getters: {
    allKegelbahnenUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.alleKegelbahnen
    },
    repairMyKegelbahnUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.repairMyKegelbahn
    },
    byNewKegelbahnUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.byNewKegelbahn
    },
    getCurrentRepairCost: (state, getters) => {
      return Math.ceil(state.kegelbahn.kosten * state.kegelbahn.repair_cost)
    },
    ausbauStatus: (state, getters) => {
      return Math.ceil((state.ausbau.currentVal * 100) / state.ausbau.kegelbahn.dauer)
    },
    ausbauStatusText: (state, getters) => {
      let tage = 0
      if (state.ausbau.kegelbahn.dauer) {
        tage = state.ausbau.kegelbahn.dauer - state.ausbau.currentVal
      }
      let spieltag = ' Spieltage'
      if (tage === 1) {
        spieltag = ' Spieltag'
      }
      return 'Verbleibende Tage bis Fertigstellung: ' + tage + spieltag
    }
  },
  actions: {
    async byNewKegelbahn ({ commit, getters, dispatch }, kegelbahnId) {
      // set transport options
      const transportOptions = {
        data: { kegelbahnId: kegelbahnId },
        url: getters.byNewKegelbahnUrl
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set ausbau
        commit(type.KEGELBAHN_SET_AUSBAU, response.data.ausbau)
        // set new money
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
        commit(type.ROOT_SET_SNACKBAR, 'Glückwunsch, Du hast Dir eine neue Kegelbahn gekauft', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // login an user
    async getAllKegelbahnen ({ state, commit, getters, dispatch, rootState }) {
      // checkif cache is valid
      const currentTime = Math.floor(new Date().getTime() / 1000) // in sec
      if (state.kegelbahnen.length > 0 && currentTime < (state.cacheTime + rootState.cacheTimeout)) {
        return true
      }
      // console.log('cache false')
      // set transport options
      const transportOptions = {
        method: 'get',
        data: { fakeData: true },
        url: getters.allKegelbahnenUrl,
        withoutAuth: true
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        commit(type.KEGELBAHN_SET_KEGELBAHNEN, response.data.kegelbahnen)
        commit(type.KEGELBAHN_SET_CACHE_TIME)
      } else {
        ret = false
      }

      return ret
    },
    // login an user
    async repairMyKegelbahn ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        data: { fakeData: true },
        url: getters.repairMyKegelbahnUrl
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set new zustand
        commit(type.KEGELBAHN_SET_ZUSTAND, response.data.zustand)
        // set new money
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
      } else {
        ret = false
      }

      return ret
    }
  }
}
